import { PersonFields } from './PersonFields';

export function StudentProfileForm({ student, onChange }) {
  return (
    <div className="px-5 py-6 sm:px-8 sm:py-7">
      <div className="rounded-2xl border-2 border-slate-200 bg-white p-5 shadow-sm sm:p-6">
        <PersonFields
          data={student}
          onChange={onChange}
          idPrefix="student"
          showName={false}
        />
      </div>
    </div>
  );
}